<template>
  <div ref="googleLoginBtn"/>
</template>

<script>
import useAnalytics from '@shared/composables/analytics.js'

export default {
  props: {
    variant: {
      type: String,
      default: 'signup',
      validator: value => {
        return value.match(/(signup|login)/)
      }
    },
    width: {
      type: Number,
      default: 400
    }
  },
  setup () {
    const { track } = useAnalytics()
    return { track }
  },
  data () {
    return {
      params: {
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID
      }
    }
  },
  watch: {
    width (width) {
      window.google?.accounts.id.renderButton(
        this.$refs.googleLoginBtn, {
          text: this.variant === 'signup' ? 'signup_with' : 'continue_with',
          size: 'large',
          width, // max width 400
          theme: 'outline'
        }
      )
    }
  },
  mounted () {
    const onload = () => {
      const gClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
      window.google.accounts.id.initialize({
        client_id: gClientId,
        callback: this.handleCredentialResponse,
        prompt_parent_id: this.id
      })
      const width = this.width
      window.google.accounts.id.renderButton(
        this.$refs.googleLoginBtn, {
          text: this.variant === 'signup' ? 'signup_with' : 'continue_with',
          size: 'large',
          width: width, // max width 400
          theme: 'outline',
          click_listener: this.onClick
        }
      )
    }
    const id = '_google-sign-in-script'
    if (document.getElementById(id)) {
      onload()
      return
    }
    const script = document.createElement('script')
    script.id = id
    script.type = 'text/javascript'
    script.onload = onload
    script.src = 'https://accounts.google.com/gsi/client'
    document.head.appendChild(script)
  },
  methods: {
    onClick () {
      this.track('Clicked third party signup', { buttonName: 'Google' })
    },
    async handleCredentialResponse (response) {
      const formData = {
        google_token: response.credential
      }
      this.$emit('success', formData)
    }
  }
}
</script>
